'use strict';

var RulesToolbarController = function RulesToolbarController($scope, $rootScope, userPreferencesService) {
  $scope.triggerSearch = function () {
    $rootScope.$broadcast('search-criteria:searchChangeEvent');
  };
  $scope.setDefaultListing = function () {
    var defaultList = userPreferencesService.getUserSettingComponent('defaultRuleStrategyListing', 'rulesAndStrategies');
    return defaultList === 'myRulesStrategies';
  };
};
RulesToolbarController.$inject = ['$scope', '$rootScope', 'UserPreferencesService'];
module.exports = RulesToolbarController;